/**
 * Global copy
 * - Move here if a localized constant needs to be accessible from multiple directories
 *   > Example: Component copy needs to be shared in /utils
 * - Create a specific file for the copy
 *   > Example: /components/supportApi/definitions/copy.ts => /definitions/copy/supportApi.ts
 * - Export all definitions from this file
 *   > Example: export { default as supportApiCopy } from './supportApi.ts';
 */
const copy = {
  breadcrumb: {
    homePageLabel: 'Twilio Support Home Page',
  },
};

export { copy };
